import { Download } from 'lucide-react'
import { useMemo } from 'react'

import { useWebContent } from '../../hooks/useWebContent'
import { richTextListClassName } from '../../utils/richText'

const getMobileOS = (): 'android' | 'ios' | null => {
    const ua = navigator.userAgent
    if (/android/i.test(ua)) return 'android'
    if (/iPad|iPhone|iPod/.test(ua)) return 'ios'
    return null
}

const GOOGLE_PLAY_LINK = import.meta.env.VITE_GOOGLE_PLAY_LINK
const APP_STORE_LINK = import.meta.env.VITE_APP_STORE_LINK

export const DownloadAppSection = () => {
    const { getText } = useWebContent('NEWSLETTER')
    const mobileOS = useMemo(() => getMobileOS(), [])

    if (!mobileOS) return null

    const downloadLink = mobileOS === 'android' ? GOOGLE_PLAY_LINK : APP_STORE_LINK

    return (
        <section className="bg-white py-24">
            <div className="mx-auto max-w-[1100px] px-6">
                <div className="relative flex flex-col items-center gap-16 overflow-hidden rounded-[3rem] border border-primary/10 bg-primary/[0.03] p-10 md:p-20 lg:flex-row">
                    <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-brand-yellow/10 blur-[100px]" />
                    <div className="absolute -bottom-20 -left-20 h-80 w-80 rounded-full bg-primary/10 blur-[100px]" />

                    <div className="relative z-10 flex-1 text-left">
                        <h2 className="mb-8 text-3xl font-bold leading-tight text-brand-dark md:text-5xl">
                            {getText('heading')}
                        </h2>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: getText('description'),
                            }}
                            className={`mb-0 text-lg leading-relaxed text-brand-gray ${richTextListClassName}`}
                        />
                    </div>

                    <div className="relative z-10 w-full flex-1">
                        <a
                            href={downloadLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-3 rounded-2xl bg-primary px-8 py-5 text-lg font-bold text-white shadow-xl shadow-primary/20 transition-all hover:bg-primary/90"
                        >
                            {getText('buttonText')}
                            <Download className="h-5 w-5" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
